var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKeys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4167 15.7585C19.4154 11.2157 15.7498 7.43073 10.982 7.04932C6.21415 6.66792 1.93313 9.81716 1.13134 14.2957C0.329542 18.7743 3.27418 23.0897 7.90696 24.2254V33.1658C7.90696 34.3729 8.93757 35.3514 10.2089 35.3514C11.4802 35.3514 12.5108 34.3729 12.5108 33.1658V24.2254C16.5771 23.2286 19.4177 19.7458 19.4167 15.7585Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7705 24.0629C21.0048 23.8957 22.193 23.4896 23.266 22.8681L30.9957 30.4508C31.9228 31.3294 33.3965 31.3168 34.3079 30.4225C35.2194 29.5282 35.2322 28.0823 34.3367 27.1726L26.6023 19.5899C28.7845 15.9634 28.202 11.3494 25.184 8.35481C22.166 5.36021 17.4704 4.73702 13.75 6.83732",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66797 12.6849C6.66797 14.2497 7.9365 15.5182 9.5013 15.5182C11.0661 15.5182 12.3346 14.2497 12.3346 12.6849C12.3346 11.1201 11.0661 9.85156 9.5013 9.85156C7.9365 9.85156 6.66797 11.1201 6.66797 12.6849Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08203 9.85156V4.16117C8.08203 2.60947 9.98482 1.35156 12.332 1.35156C14.6792 1.35156 16.582 2.60947 16.582 4.16117V5.39615",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeys);
export default __webpack_public_path__ + "static/media/Icon_keys.38571069.svg";
export { ForwardRef as ReactComponent };